
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programs/[program]",
      function () {
        return require("private-next-pages/programs/[program].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programs/[program]"])
      });
    }
  